import { ChangeEventHandler, FC, ReactNode } from "react";
import "./style.scss";
import ArrowBottom from "@/src/svg/header/ArrowBottom";

interface ISelectDefault {
  reverse?: boolean;
  children: ReactNode;
  value: string;
  onChange?: ChangeEventHandler<HTMLSelectElement>;
  disabled?: boolean;
}

const SelectDefault: FC<ISelectDefault> = ({ children, value, onChange, reverse, disabled }) => {
  return (
    <div className={`select-default ${reverse ? "reverse" : ""} ${disabled ? "disabled" : ""}`}>
      <select onChange={onChange} value={value} disabled={disabled}>
        {children}
      </select>
      <ArrowBottom />
    </div>
  );
};

export default SelectDefault;
